import styled, { css } from 'styled-components/macro';

import { CheckboxContainer } from 'components/base/LabeledCheckbox/LabeledCheckbox';
import { CheckboxLabel } from 'components/base/CheckboxDropdown/styles';
import Box from 'components/elements/Box';
import Button from 'components/elements/button';
import { DefinitionLabel } from 'styles/base-classes';
import { List } from 'components/Selector/DSPSelector/SelectedDSPList/SelectedDSPList';
import { Displayname } from './ViewItem';

export const EditViewModal = styled('section')<any>`
  svg > g {
    stroke: ${({ theme }): string => theme.CasperGrey};
  }
  ${Box}.title > ${Button} {
    padding: 0;
  }
  ${Box} ${CheckboxLabel} {
    font-size: 1em;
    text-transform: capitalize;
    & > span {
      color: ${({ theme }): string => theme.NightBlue};
    }
  }
  ${({ isMobile }): any =>
    isMobile &&
    css`
      position: relative;
    `}
`;

export const Content = styled('div')<any>`
  padding: ${({ theme }): string => theme.spacing.xlarge};
  @media screen and (max-width: 36rem) {
    padding: ${({ theme }): string => theme.spacing.medium};
  }
  ${({ isMobile }): any =>
    isMobile &&
    css`
      max-height: ${({ theme }): string =>
        `calc(100vh - 2 * ${theme.spacing.small})`};
      @-moz-document url-prefix() {
        max-height: 100%;
      }
      overflow: hidden;
    `}
`;

export const CustomListTitle = styled(DefinitionLabel)`
  font-size: 1em;
  font-weight: bold;
  letter-spacing: 0.86px;
  @media screen and (max-width: 36rem) {
    margin: ${({ theme }): string => theme.spacing.small} 0;
  }
`;

export const H1 = styled('h1')`
  font-size: 1.5em;
  margin-bottom: 0.42em;
  @media screen and (max-width: 36rem) {
    margin-bottom: 0;
  }
`;

export const Label = styled(DefinitionLabel)`
  font-size: 0.75em;
  font-weight: bold;
`;

export const P = styled('p')`
  padding: ${({ theme }): string =>
    `${theme.spacing.small} 0 ${theme.spacing.medium}`};
  margin: 0;
  @media screen and (max-width: 36rem) {
    padding-top: 0;
  }
`;

export const BoxColumns = styled(Box)<any>`
  flex-wrap: wrap;
  @media screen and (max-width: 36rem) {
    & > ${Box} {
      flex-basis: 100%;
    }
  }
  ${({ isMobile }): any =>
    isMobile &&
    css`
      max-height: ${({ theme }): string =>
        `calc(100vh - 2 * ${theme.spacing.small})`};
      overflow-y: auto;
      padding-bottom: 13em;
    `}
`;

export const BoxLeft = styled(Box)<{ isLow?: boolean }>`
  ${CheckboxContainer} {
    padding: ${({ isLow }) => (isLow ? '0.562em 0;' : '0.982em 0')};
  }
`;

export const CheckboxList = styled(Box)`
  @media screen and (max-width: 36rem) {
    justify-content: stretch;
    padding: 0 1em;
  }
`;

export const DraggedList = styled(List)<{ isLow?: boolean }>`
  width: 100%;
  & > li {
    @media screen and (max-width: 36rem) {
      padding: 0 1em;
    }
    ${Displayname} {
      ${({ isLow }) =>
        isLow &&
        css`
          line-height: 1;
        `};
    }
  }
`;

export const ButtonWrapper = styled(Box)<any>`
  padding: ${({ theme }): string =>
    `${theme.spacing.small} ${theme.spacing.large}`};
  box-shadow: 1px -2px 6px 0 ${({ theme }): string => theme.LightGrey};
  background-color: ${({ theme }): string => theme.White};
  ${({ isMobile }): any =>
    isMobile &&
    css`
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
    `}
  @media screen and (max-width: 36rem) {
    padding: ${({ theme }): string => theme.spacing.xxsmall} 0;
  }
  ${Button} {
    flex-grow: 1;
    font-size: 1em;
    font-weight: 600;
    &:not(:first-of-type) {
      margin-left: 0;
    }
    @media screen and (max-width: 36rem) {
      font-size: 11px;
    }
  }
`;
